<template>
    <BasePanel class="deposit-argentina">
        <template #content>
            <h5 class="title title__small">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_3064_38453)">
                        <path d="M0 0H24V6.66667H0V0ZM0 17.3333H24V24H0V17.3333Z" fill="#1E88E5" />
                        <path d="M0 6.66797H24V17.3346H0V6.66797Z" fill="#F8F9FD" />
                        <path
                            d="M16 11.92L14 13L15 15L13 14L12.0667 16L11 14L9 15L10 12.8L8 11.92L10 11.2L9 9L11 10L12.0667 8L13 10L15 9L14 11.2L16 11.92Z"
                            fill="#FBC02D" />
                    </g>
                    <defs>
                        <clipPath id="clip0_3064_38453">
                            <rect width="24" height="24" rx="2.66667" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                {{ tokens.newDesign.depositArgentinaTab }}
            </h5>
            <div class="deposit-argentina__inner">
                <p class="deposit-argentina__text body__medium">{{ tokens.newDesign.depositArgentinaText }}</p>
                <BaseButtonSmall 
                    @click.native="makeDeposit" 
                    :button-text="tokens.newDesign.depositArgentinaRequest"
                    :button-style="'outlined-primary'"
                >
                    <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M12.1426 12.7022L12.0984 11.0376H9.09316L14.7855 5L13.5355 3.75L7.91465 9.85908L7.91465 6.85387L6.25 6.80968V12.7022H12.1426Z"
                                fill="var(--System-Primary)" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 17.5V15.8334H2.5L2.5 17.5H17.5Z"
                                fill="var(--System-Primary)" />
                        </svg>
                    </template>
                </BaseButtonSmall>
            </div>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import { NOTIFICATION_ERROR } from "@/store/mutations.type"
import { mapGetters } from "vuex"
import { DEPOSIT_REQUEST } from "@/store/actions.type"

import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall.vue"

export default {
    name: "BitHideTab",
    components: { BasePanel, BaseButtonSmall },
    computed: {
        ...mapGetters(['tokens', 'variables', 'deposits']),
    },
    methods: {
        makeDeposit() {
            this.$store.dispatch(DEPOSIT_REQUEST, {
                psp: 'depositForArgentina',
            }).catch(() => {
                this.$store.commit(NOTIFICATION_ERROR, "Something went wrong. Please try again later.")
            })
        },
    },
}
</script>

<style scoped>
.deposit-argentina {
    padding: 16px;
}

.title {
    color: var(--System-OnSurface);
    text-align: left;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.deposit-argentina__inner {
    border-radius: 4px;
    background: var(--System-Surface1);
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

}

.deposit-argentina__text {
    color: var(--System-OnSurface)
}
</style>
